import styled, { css } from 'styled-components';
import Button from 'src/components/buttons/button';
import { titleSmall } from 'styles-js/mixins/typography';
import { Select } from 'styles-js/form';

export const Fieldset = styled.fieldset`
  margin-top: 20px;
`;

export const FixedHeightInnerBody = styled.div<{ $isCentered?: boolean }>`
  height: 470px;
  @media (max-width: ${({ theme }) => theme.screenXsMin}) {
    height: 100%;
  }
  @media (max-height: ${({ theme }) => theme.screenSmMinHeight}) {
    height: 100%;
  }

  ${({ $isCentered }) => $isCentered && css`
    display: flex;
    flex-direction: column;
    justify-content: center;
  `};

  ::after { // this ensures bottom space for long screens
    content: '';
    display: block;
    height: 30px;
  }
`;

export const Legend = styled.legend`
  ${titleSmall};
  margin-bottom: 10px;
`;

export const Label = styled.label`
  ${titleSmall};
  display: block;
  margin-bottom: 10px;
`;

export const StyledSelect = styled(Select)<{ $isInvalid?: boolean, $edited?: boolean }>`
  width: 100%;
  margin: 5px 0;
  border-color: ${({ $isInvalid: isInvalid, theme }) => isInvalid ? theme.colorError : theme.colorGreyLight};
  color: ${({ $edited: edited, theme }) => edited ? theme.colorTextBlack : theme.colorTextLight};
`;

export const QuestionListItem = styled.label<{ $isChecked?: boolean; $isInvalid?: boolean; }>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 20px 15px;
  margin: 0;
  background-color: ${({ $isChecked, theme }) => $isChecked ? theme.colorBlueBackground : theme.colorWhite};
  transition: all 0.3s ease;
  border: 2px solid ${({ theme }) => theme.colorGreyLight};
  border-width: 0 2px 2px 2px;
  cursor: pointer;

  &:first-of-type {
    border-top-width: 2px;
    border-radius: 8px 8px 0 0;
  }

  &:last-of-type {
    border-radius: 0 0 8px 8px;
  }

  @media (${props => props.theme.underScreenXxsmall}) {
    padding: 15px 10px;
  }

  ${({ $isInvalid }) => $isInvalid && css`
    border-right-color: ${({ theme }) => theme.colorError};
    border-left-color: ${({ theme }) => theme.colorError};
    &:first-of-type {
      border-top-color: ${({ theme }) => theme.colorError};
    }
    &:last-of-type {
      border-bottom-color: ${({ theme }) => theme.colorError};
    }
  `};

  input[type="checkbox"],
  input[type="radio"] {
    cursor: pointer;
  }
`;

// also used in components/conditionCard
export const Card = styled.div<{ $showWarning?: boolean }>`
  border: solid 2px ${props => props.$showWarning ? props.theme.colorDanger : props.theme.colorGreyLight};
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 10px;
  position: relative;
`;

export const AddableHealthTag = styled(Button)`
  border: 2px solid ${({ theme }) => theme.colorGreyLight};
  background-color: transparent;

  .icon-plus {
    font-size: ${({ theme }) => theme.fontSizeXs};
    color: ${({ theme }) => theme.colorBlue};
  }
`;
